
 import { forwardRef } from "react";

  const AboutBanner=forwardRef((props ,ref)=> {
  const { onNavigate } = props;

  // const handleScroll = () => {
  //   document
  //     .getElementById("about-scroll")
  //     .scrollIntoView({ behavior: "smooth" });
  // };

  return (
    <>
    <section className="aboutpage-banner" ref={ref}>
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <div className="aboutbanner-box">
                      <div className="aboutbanner-tittle">
                        <h1 className="heading">About Us</h1>
                        <span>Our Story</span>
                      </div>

                      <div className="aboutbanner-para">
                          <span onClick={onNavigate}>scroll</span>
                          <p>Saysha Interiors not just transforms spaces, but we breathe life into them. Our adept team puts every effort into elevating your space with luxurious reimagination and personalization.</p>
                      </div>
                    </div>
                </div>
    
            </div>
        </div>

        <img src="/image/about-banner.webp" className="banner-aboutimage" alt="about"/>
        <div className="banner-topoverlay"></div>
    </section>
    </>
  )
})
export default AboutBanner;
